import { Vector3 } from 'three'
import * as THREE from 'three';
import React, { useMemo, useRef, useCallback, useEffect } from 'react'
import { Background } from '../bg.js';
import {useFx} from '../fx.js';

const bgPosition = new Vector3(0,0,0)
function App(){
	const fx = useFx();
	const bgReady = useCallback(()=>{
		fx.ready()
	},[fx])
	return(
		<>
			<Background position={bgPosition} readyFun={bgReady} />
		</>
	)
}
const EffectSimple = {
	App,
	config: {
		createCamera: ()=>{
			const cam = new THREE.PerspectiveCamera(50, 1, 0.1, 1000)
			cam.position.z = 40
			cam.lookAt(0, 0, 0)
			return cam
		}
	}
}
export {EffectSimple};
